export default "__VITE_ASSET__BVaJJ3iA__"